<template>
<!-- FINAL ICARE -->
  <form @submit.prevent>
     <CModal
        :title.sync="title" 
        color="info"
        :closeOnBackdrop ="false"
        :show.sync="show">
        <CRow>
          <CCol>
            <b-form-select v-model="form.icare_id" :options="options"></b-form-select>
          </CCol> 
          </CRow>
       
        <template #footer>
        <CButton @click="show = false" color="danger">Cancel</CButton>
        <CButton  v-if="mode === 'edit'" type="submit" v-on:click.prevent="assign_icare(form.uuid,form.icare_id)"  variant="outline" color="info">Update</CButton>
        
        </template>
    </CModal>
  </form>
</template>

<script>
import EventBus from '@/eventBus';

import icare from '@/services/icare'
import newcomer from '@/services/newcomer';

import moment from 'moment';

export default {
name: 'icaremodal',
  data () {
    return {
    show: false,
    title: 'Default Title',
    mode: '',
    form:{
      uuid:'',
      name:'',
      icare_id:'',
    },
    options:[],
   
    }
  },
  
  mounted (){
    
   },
  created () {
    var self = this; 
      EventBus.$on('OPEN_MODAL_NEWCOMER_ICARE', (params) => {
      if(params.data){
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = params.data;
        self.form.icare_id = res.data.icare_id;
      }else{
        self.show = true;
        self.title = params.title;
        self.mode = params.mode;
        self.form.uuid = "";
        self.form.icare_id = "";
      }
    });
    //this.form.uuid = this.$route.query.Pud
    this.options = []
    icare.getIcare()
    .then(res => {
      for (let i=0; i <= res.data.length-1; i++){
        this.options.push({text: res.data[i].name, value:res.data[i].id})
      }
    }).catch((er) =>{
      var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
    })
  },
  methods: {
    open () {
      this.show = true;
    },
    close () {
      this.show = false;
    },
    assign_icare(id,icare_id){
      // alert("id:"+id+" / icare_id:"+icare_id)
      this.show = false;
        if(confirm("Do you really want to assign this icare ?")){
          var param = {
            icare_id: icare_id,
          }
          newcomer.assign_icare(id, param)
          .then(res => {
            //this.load()
            EventBus.$emit('TABLE_UPDATE_NC_WANT_ICARE', true)
            console.log(id, param)
            var params = {title: 'Success', mode:'success', data:res.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          }).catch ((err) => {
            var params = {title: 'Error', mode:'danger', data:err.response.data.message}
            EventBus.$emit('OPEN_MODAL_ALERT', params)
          })
        }
      },
     
    
   
  }
}
</script>

<style>

</style>